import React from 'react'
import { DefaultLayout } from '../../layouts'
import { SimplePageHeader } from '../../components'
import { MainContent } from './components'
import { useSelector } from 'react-redux'

const TermsConditions = () => {
  const translation = useSelector(state => state.translation.data)
  const language = useSelector(state => state.system.language)

  return (
    <DefaultLayout>
      <SimplePageHeader title={translation.GENERAL.tnc[language.name]} largePadding />
      <MainContent />
    </DefaultLayout>
  )
}

export { TermsConditions }
